module.exports = __webpack_public_path__ + "img/text_ad.077587da.svg";